import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import AOS from 'aos'
import 'aos/dist/aos.css'

import i18n from "./lang"; // Internationalization

// 引入 vue-awesome-swiper
import Swiper from "vue-awesome-swiper";
//引入 vue-awesome-swiper 样式
import "swiper/css/swiper.css";
Vue.use(Swiper);

Vue.config.productionTip = false;

import "@/utils/rem.js";

import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";

import SvgIcon from "./components/SvgIcon.vue";
Vue.component("svg-icon", SvgIcon);

import "./style/main.scss";

import http from "./utils/request.js";
Vue.prototype.$http = http;

// Vue.use(ElementUI);
//element官方方法 //为了实现element插件的多语言切换
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

import Layout from "@/views/layout/index";
// 注册全局组件
Vue.component("Layout", Layout);

//scrollto指令注册
import "./utils/scrollTo";

Vue.prototype.trim = function (s) {
  return s.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
};
AOS.init()

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
